const listOfFeatures = [
    { span: 5, height: "24px" },
    {
        classes: "marginTop-24",
        columns: [
            { span: 2, height: "88px" },
            {
                span: 4,
                rows: [
                    { span: 2, height: "24px" },
                    { span: 4, height: "24px", classes: "marginTop-4" },
                    { span: 4, height: "24px", classes: "marginTop-4" },
                ],
            },
        ],
    },
    {
        classes: "marginTop-24",
        columns: [
            { span: 2, height: "88px" },
            {
                span: 4,
                rows: [
                    { span: 2, height: "24px" },
                    { span: 4, height: "24px", classes: "marginTop-4" },
                    { span: 4, height: "24px", classes: "marginTop-4" },
                ],
            },
        ],
    },
    {
        classes: "marginTop-24",
        columns: [
            { span: 2, height: "88px" },
            {
                span: 4,
                rows: [
                    { span: 2, height: "24px" },
                    { span: 4, height: "24px", classes: "marginTop-4" },
                    { span: 4, height: "24px", classes: "marginTop-4" },
                ],
            },
        ],
    },
]

export default listOfFeatures
